<template>
    <div class="detail">
        <div class="header">
            <div class="left" @click="toIndex()">< 返回</div>
            <div class="span1">
                材料详情
            </div>
            <div class="right"></div>
        </div>
        <div class="main">
            <div class="img_box">
                <img v-for="(item,i) in img_list" :key="i+'img_li'" :src="item.previewUrl" alt="">
            </div>
            <div class="main-li">
                <p>材料名称</p>
                <span>{{info.mname}}</span>
            </div>
            <div class="main-li">
                <p>材料价格</p>
                <span>￥{{info.price}}</span>
            </div>
            <div class="main-li">
                <p>学科类型</p>
                <span>{{info.subjectType=='0'?'学科类':'非学科类'}}</span>
            </div>
            <div class="main-li">
                <p>使用期限</p>
                <span>{{info.useStartEndTime}}</span>
            </div>
            <div class="main-li">
                <p>材料描述</p>
                <span>{{info.describe}}</span>
            </div>
            <div class="main-li">
                <p>材料类型</p>
                <span>{{info.classify=='0'?'线上材料':'线下材料'}}</span>
            </div>
            <!-- 线上材料 -->
            <template v-if="info.classify=='0'">
                <div class="main-li">
                    <p>下载网站</p>
                    <span>{{info.downloadSite}}</span>
                </div>
                <div class="main-li">
                    <p>开发者</p>
                    <span>{{info.developerInfo}}</span>
                </div>
                <div class="main-li">
                    <p>资源主题</p>
                    <span>{{info.resourcesTheme}}</span>
                </div>
                <div class="main-li">
                    <p>资源简介</p>
                    <span>{{info.resourceProfile}}</span>
                </div>
                <div class="main-li">
                    <p>适用对象</p>
                    <span>{{info.suitableObject}}</span>
                </div>
                <div class="main-li">
                    <p>图文来源</p>
                    <span>{{info.graphicSource}}</span>
                </div>
            </template>
            <!-- 线下材料 -->
            <template v-if="info.classify=='1'">
                <div class="main-li">
                    <p>编写者</p>
                    <span>{{info.authorInfo}}</span>
                </div>
                <div class="main-li">
                    <p>材料简介</p>
                    <span>{{info.synopsis}}</span>
                </div>
                <div class="main-li">
                    <p>材料内容</p>
                    <span>{{info.content}}</span>
                </div>
                <div class="main-li">
                    <p>适用对象</p>
                    <span>{{info.suitableObject}}</span>
                </div>
            </template>
            <div class="main-title" style="margin-top:50px">
				<img src="./img/title-4.svg" alt="">
				<p>审核记录</p>
			</div>
			<!-- 材料审核流程 -->
			<div>
				<div class="handle">
					<div v-for="(item,i) in info.operateList" :key="i+'材料审核记录'" class="handle-item">
						<img src="./img/reject.svg" alt="" v-if="item.auditState==='3'"/>
						<img src="./img/pass.svg" alt="" v-else/>
						<div class="handle-title">
							<p v-if="item.auditState">{{stateObj[item.auditState]}}</p>
							<p class="text">{{item.operateOpinion}}</p>
						</div>
						<span class="handle-name">{{item.operateOrgName || item.operateName}}</span>
						<span class="handle-time">{{ dayjs(item.operateTime).format('YYYY-MM-DD hh:mm') }}</span>
						<div class="line" v-if="i < item.operateOrgName.length-1"></div>
					</div>
				</div>
				<template v-if="type!=='manager' && info.auditState=='1'">
				<div class="main-title" style="margin-top:50px">
					<img src="./img/title-5.svg" alt="">
					<p>审核意见</p>
				</div>
				<el-input style="margin-top:20px" type="textarea" resize="none" :rows="6" placeholder="请输入" v-model="textarea">
				</el-input>
				</template>
			</div>

			<!-- 材料管理-详情 -->
			<!-- <div v-if="type==='manager'">
				<div class="main-li m-t">
					<p>审核时间</p>
					<span v-if="info.operateList&&info.operateList.length">{{ dayjs(info.operateList[info.operateList.length-1].operateTime).format('YYYY-MM-DD hh:mm') }}</span>
				</div>
				<div class="main-li">
					<p>审核单位</p>
					<span v-if="info.operateList&&info.operateList.length">{{info.operateList[info.operateList.length-1].operateOrgName}}</span>
				</div>
				<div class="main-li">
					<p>审核结果</p>
					<span v-if="info.operateList&&info.operateList[info.operateList.length-1].auditState">{{stateObj[info.operateList[info.operateList.length-1].auditState]}}</span>
				</div>
			</div> -->
		</div>
		<footer v-if="type!=='manager' && info.auditState=='1'">
			<el-button style="width:120px;" size="small" @click="toHandle('3')">审核不通过</el-button>
			<el-button style="width:120px;margin-left:20px;" type="primary" size="small" @click="toHandle('2')">审核通过</el-button>
	    </footer>
    </div>
</template>
<script>
import util from '@/utils/util.js'
import dayjs from "dayjs";
import educationApi from '@/api/education/index.js';
export default {
	props:['info','type'],
	components:{
        
    },
	data() {
		return {
			img_list:[],
            stateObj:{
				'1':'申请审核',
				'2':'审核通过',
				'3':'审核不通过',
				'4':'已下架',
			},
			textarea:'',
		}
	},
	computed:{

	},
	watch: {
		info:{
			async handler(n,o){
                this.img_list= this.info.resource.filter(e=>e.source=='0');
			},
			deep:true
		}
	},
	created() {
		
	},
	methods: {
        dayjs,
		getFileType(ext){
			return util.getFileType(ext);
		},
        toIndex(){
            this.$emit('to-index')
        },
		async toHandle(state){
			if(!this.textarea){
				this.$message({type: "error",message: "审核意见不能为空",});
				return false;
			}
			let params={
				mid:this.info.mid,
				auditState:state,
				operateOpinion:this.textarea,
				orgId:'54796182c66e11eabae602cbc4c02197',
			}
			let res=await educationApi.educationMaterialsAudit(params);
			if (res.result == "000000") {
				this.$message({type: "success",message: "操作成功",});
				this.textarea='';
				this.$emit('to-init');
				this.toIndex();
			} else {
				this.$message({type: "error",message: "操作失败",});
			}
		},
	},
	mounted() {},
}
</script>
<style lang="less" scoped>
.detail {
	width: 100%;
    padding: 0px 30px 30px 30px;
	.header {
		height: 60px;
		line-height: 48px;
		margin-bottom: 20px;
		display: flex;
		justify-content: space-between;
        align-items: center;
		.span1 {
			font-family: 'PingFang SC Bold';
			font-size: 20px;
			color: #000;
		}
        .left, .right{
            width: 60px;
        }
        .left{
            cursor: pointer;
        }
	}
	.main{
		width: 100%;
		height: 100%;
		.main-title{
			display: flex;
			align-items: center;
			p{
				font-weight: bold;
				font-size: 14px;
				color: #181c26;
				margin-left: 10px;
			}
		}
		.main-li{
			margin-top: 20px;
			width: 100%;
			display: flex;
			// align-items: center;
			font-size: 14px;
			color: #888;
			p{
				width: 120px;
				text-align: right;
				margin-right: 20px;
			}
			span{
				width: calc(100% - 220px);
				word-wrap:break-word;
			}
		}
	}
    .img_box{
        padding: 0 20px 0 70px;
        img{
            max-width: 350px;
            margin-right: 20px;
        }
    }
    .handle-item{
		width: 100%;
		height: 50px;
		margin-top: 20px;
		font-size: 14px;
		display: flex;
		align-items: flex-start;
		padding-left: 80px;
		position: relative;
		.line{
			position: absolute;
			width: 1px;
			height: calc(100% + 10px);
			background: #EEEEEE;
			left: 90px;
			top: calc(50% - 5px);
		}
		.handle-title{
			width: 50%;
			margin-left: 15px;
			.text{
				color: #888;
			}
		}
		.handle-name{
			width: 150px;
			text-align: right;
		}
		.handle-time{
			margin-left: 20px;
			color: #888;
		}
	}
}
footer{
	margin-top: 50px;
	display: flex;
	justify-content: center;
}
</style>
